import MailCampaign from 'App/resources/Model/MailCampaign';

export const shouldUseUpsalesEditor = (mailCampaign: MailCampaign) => {
	const campaignVersion = mailCampaign.version;
	const templateVersion = mailCampaign.template?.version;
	const version = campaignVersion ?? templateVersion;

	// Default to version 1 if no version is specified
	return version === 1 || !version;
};

export const isUnlayerTemplate = (mailCampaign: MailCampaign) => {
	return mailCampaign.version === 2 || (mailCampaign.template && mailCampaign.template.version === 2);
};
